// Verbindung zum BusLab-Server. Alles ist optional: Ohne Server (oder offline) läuft das
// Lab rein lokal weiter, es wird dann nur nichts gezählt.

import type { AufbauLoesung, Schritt } from "./model.ts";

export interface CountInfo { round_active: boolean; solved_count: number | null }

function randomId(): string {
  if (typeof crypto.randomUUID === "function" && window.isSecureContext) return crypto.randomUUID();
  // Fallback für unsichere Kontexte (http im LAN): crypto.getRandomValues gibt es trotzdem
  const b = crypto.getRandomValues(new Uint8Array(16));
  const h = Array.from(b, x => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

let cachedId: string | null = null;

/** Zufällige, anonyme Browser-ID; verhindert nur Doppelzählungen pro Gerät. */
export function clientId(): string {
  if (cachedId) return cachedId;
  try {
    cachedId = localStorage.getItem("buslab:client");
    if (!cachedId) {
      cachedId = randomId();
      localStorage.setItem("buslab:client", cachedId);
    }
  } catch {
    cachedId = randomId();
  }
  return cachedId;
}

async function post<T>(path: string, body: unknown): Promise<T | null> {
  try {
    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    return res.ok ? ((await res.json()) as T) : null;
  } catch {
    return null;
  }
}

export const api = {
  open: (taskId: string) =>
    post<CountInfo>("api/open", { task_id: taskId, client_id: clientId() }),
  solve: (taskId: string, loesung: AufbauLoesung | { takte: Schritt[] }, hints: number) =>
    post<CountInfo & { solved: boolean; counted: boolean }>(
      "api/solve", { task_id: taskId, client_id: clientId(), loesung, hints }),
};
